
export const DAYS_OF_WEEK = [ "sun", "mon", "tue", "wed", "thu", "fri", "sat" ];

export const DEFAULT_TERRITORY = '001';
